export var normalizeLocale = function normalizeLocale(locale) {
  return locale.replace(/_/g, '-');
};